//  ANGULAR ----------------------------------------------
import { Component, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";

// PRIME NG ----------------------------------------------
import { ToastModule } from "primeng/toast";

//  CUSTOM -----------------------------------------------
import { NavbarComponent, ToastMessagesComponent } from "@core/components";
import { CoreService } from "@core/services/core.service";
import { GlobalService } from "@shared/services";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [RouterOutlet, NavbarComponent, ToastModule, ToastMessagesComponent],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
})
export class AppComponent {
  coreService = inject(CoreService);
  globalService = inject(GlobalService);

  isApaApp = this.globalService.isApaApp;
  isApaAppV3 = this.globalService.isApaAppV3;

  ngOnInit(): void {
    this.coreService.init();
  }
}
